import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import axios from './axios';

export interface UseForgotPasswordVariables {
  email: string;
}

export interface UseForgotPasswordData {}

export type UseForgotPasswordErrorData =
  | {
      email?: string;
    }
  | string[];

export function useForgotPassword() {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<
    UseForgotPasswordData,
    AxiosError<UseForgotPasswordErrorData>,
    UseForgotPasswordVariables
  >(
    (variables) => {
      const data = variables;

      return axios
        .post<UseForgotPasswordData>('/posht/ashena/forgot-password/', data)
        .then((res) => res.data);
    },
    {
      onError: (data) => {
        if (data.response?.status === 400) {
          enqueueSnackbar(
            Array.isArray(data.response?.data)
              ? data.response?.data[0]
              : data.response?.data.email,
            {
              variant: 'error',
            },
          );
        } else {
          enqueueSnackbar(t('errors.unknown'), { variant: 'error' });
        }
      },
      onSuccess: () => {
        enqueueSnackbar(t('landing.forgotPasswordEmailSent'), {
          variant: 'success',
        });
      },
    },
  );
}
